<template>
  <div class="imgupload" v-loading="fullscreenLoading">
    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline" size="mini" ref="sendDataInfo"
      :show-message="false">
      <el-form-item>
        <el-upload class="upload-demo" ref="upload" :action="requesUrl + uploadUrl" :limit="limit" name="file"
          :headers="header" :on-preview="handlePreview" :file-list="fileList" :on-error="uploadFalse"
          :on-success="uploadSuccess" :auto-upload="false" :http-request="handleUploadForm">
          <el-button slot="trigger" size="small" type="primary">选取excel文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload()">提交上传</el-button>
          <!-- <div slot="tip" class="el-upload__tip">只能上传excel文件</div> -->
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import FileSaver from "file-saver";
import $XLSX from "xlsx";

export default {
  name: 'importFile',
  data() {
    return {
      dialogVisible: false,
      file: "",
      tableData: [],
      tableHead: [],
      sendDataInfo: {
      },
      searchType: '',
      setField: '',
      nowField: "",
      fullscreenLoading: false,
      fileList: [],
      sField: '',
      requesUrl: '',
      otherData: {
        state: 0
      },
      requesUrl: this.$store.getters.getConfig.requestUrl,

    };
  },
  props: {
    header: {
      type: Object,
      default: () => {
        return {
          'Content-Type': 'multipart/form-data',
          token: sessionStorage.getItem('token')
        }
      },
    },
    // 最大上传数量
    limit: {
      type: [Number, String],
      default: () => 1,
    },
    // fileList: {
    //     type: Object,
    // },
    importType: {
      type: String,
      require: true,
    },
    uploadUrl: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  created() {
    this.requesUrl = this.$store.getters.getConfig.requestUrl;
  },
  methods: {
    handleUploadForm(param) {
      let formData = new FormData()

      // 在formData中加入我们需要的参数
      formData.append('file', param.file)
      formData.append('state', 0)
      // 向后端发送数据
      this.$http[this.importType](formData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.$message.success('上传成功')
          this.$emit('closeExcel', true)
        }else if (res.status==300) {
            window.location.href =this.requesUrl +"/suSettleAccount/exportOderFail"
        } else {
          this.$message.error(res.message)
        }
      })
    },
    uploadSuccess(response, file, fileList) {
        console.log(response, file, fileList);
      console.log(response);
      if (response.status == 0) {
        console.log("文件导入成功");
      } else {
        console.log("文件导入失败");
      }
    },
    uploadFalse(response, file, fileList) {
      alert("文件上传失败！");
    },
    // 导入成功时执行
    handleChange(file, fileList) {
      console.log('handleChange', file, '--', fileList);
      this.fileList = JSON.parse(JSON.stringify(fileList))
      // // 将文件放入
      // if (fileList) {
      //     for (let i = 0; i < fileList.length; i++) {
      //         if (file.name != fileList[i].name) {
      //             this.fileList.push({
      //                 name: file.name,
      //                 url: "",
      //                 uid: file.uid
      //             });
      //         }
      //     }
      //     const files = { 0: file };
      //     this.readExcel(files);
      // }
    },
    readExcel(file) {
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = $XLSX.read(data, { type: "binary" });
          const params = [];
          this.tableData = [], this.tableHead = [];
          // 取对应表生成json表格内容
          workbook.SheetNames.forEach(item => {
            this.tableData.push($XLSX.utils.sheet_to_json(workbook.Sheets[item]));
          });
          console.log('workbook', JSON.parse(JSON.stringify(this.tableData)));
          // 该算法仅针对表头无合并的情况
          if (this.tableData.length > 0) {
            // 获取excel中第一个表格数据tableData[0][0]，并且将表头提取出来
            for (const key in this.tableData[0][0]) {
              this.tableHead.push(key);
            }
          }
          // 重写数据
        } catch (e) {
          console.log("error:" + e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file[0].raw);
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
    },
    // 触发组件的提交
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file);
      console.log(JSON.parse(JSON.stringify(fileList)));
      console.log(JSON.parse(JSON.stringify(this.fileList)));
      let len = this.fileList.length
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(i, 1)
            break;
          }
        }
        // const files = { 0: file };
        // this.readExcel(files);
      }
    },
    handlePreview(file) {
      console.log(file);
      if (file.status) {
        alert("此文件导入成功");
      } else {
        alert("此文件导入失败");
      }
    },
  },
};
</script>
<style scoped>
.imgupload {
  margin-left: 68px;
  padding-bottom: 20px;
}


</style>